// extracted by mini-css-extract-plugin
module.exports = {"popover":"extendedRequestTooltip_popover__1NP0-","popoverBody":"extendedRequestTooltip_popoverBody__2bMkn","extendedText":"extendedRequestTooltip_extendedText__hnFbz"};